// extracted by mini-css-extract-plugin
module.exports = {"row":"HeaderSwitcher_row_1tQEU","text":"HeaderSwitcher_text_3XFUr","active":"HeaderSwitcher_active_zQJaf"};